module.exports = __webpack_public_path__ + "static/assets/9538806502cfdd69023a941dce2f2ce2.png";